import { render, staticRenderFns } from "./TalantCard.vue?vue&type=template&id=13b6a4d1&scoped=true&lang=pug&"
import script from "./TalantCard.vue?vue&type=script&lang=js&"
export * from "./TalantCard.vue?vue&type=script&lang=js&"
import style0 from "./TalantCard.vue?vue&type=style&index=0&id=13b6a4d1&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13b6a4d1",
  null
  
)

export default component.exports